import React from 'react';
import moment from 'moment';
import { Heading } from '../../components';

import css from './ListingPage.module.css';

/**
 * Helper: Parse event dates from JSON array format, comma-separated string, double-stringified, or single number
 */
const parseEventDates = value => {
  if (!value) return [];
  
  try {
    // Handle string format
    if (typeof value === 'string') {
      // Try JSON array first (format: "[1234567890, 2345678901]")
      try {
        const parsed = JSON.parse(value);
        
        // Handle double-stringified case where JSON.parse returns a string
        if (typeof parsed === 'string') {
          // Try parsing again
          try {
            const doubleParsed = JSON.parse(parsed);
            if (Array.isArray(doubleParsed)) {
              return doubleParsed.filter(v => typeof v === 'number' && v > 0).sort((a, b) => a - b);
            }
          } catch (innerE) {
            // Fall through to comma-separated handling
          }
        }
        
        if (Array.isArray(parsed)) {
          return parsed.filter(v => typeof v === 'number' && v > 0).sort((a, b) => a - b);
        }
      } catch (e) {
        // JSON parse failed, try comma-separated format
      }
      
      // Handle comma-separated string format (format: "1234567890,2345678901")
      const timestamps = value
        .split(',')
        .map(str => {
          const num = parseInt(str.trim(), 10);
          return !isNaN(num) && num > 0 ? num : null;
        })
        .filter(num => num !== null)
        .sort((a, b) => a - b);
      
      if (timestamps.length > 0) {
        return timestamps;
      }
    }
    
    // Handle numeric format (backward compat)
    if (typeof value === 'number' && value > 0) {
      return [value];
    }
    
    // Already an array
    if (Array.isArray(value)) {
      return value.filter(v => typeof v === 'number' && v > 0).sort((a, b) => a - b);
    }
  } catch (e) {
    // Fallback: return empty array on errors
  }
  
  return [];
};

const SectionEventDateMaybe = props => {
  const { eventDate, heading } = props;
  
  const dates = parseEventDates(eventDate);
  
  // Don't render if no dates
  if (dates.length === 0) {
    return null;
  }

  return (
    <section className={css.sectionText}>
      {heading ? (
        <Heading as="h2" rootClassName={css.sectionHeading}>
          {heading}
        </Heading>
      ) : null}
      <div className={css.eventDatesList}>
        {dates.map((timestamp, idx) => {
          const eventMoment = moment(timestamp);
          const formattedDate = eventMoment.format('dddd, MMMM D, YYYY');
          const isPast = eventMoment.isBefore(moment().startOf('day'));
          
          return (
            <p 
              key={timestamp} 
              className={isPast ? css.eventDatePast : css.eventDateUpcoming}
            >
              {formattedDate}
            </p>
          );
        })}
      </div>
    </section>
  );
};

export default SectionEventDateMaybe;
